// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { System, System as This } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { addQueryParametersToUrl } from "@lg/shared/for-apps";
import type { ScreenDefinition } from "@lg/shared";
import { FrontendScreenBridge } from "@lg/ng-shared";

export const $Screens = {
};
